export * from './rechnungs-vorlage-geloescht.interface';
